import React from "react";
import { ToBinRackerWrapper } from "./binRacker.style";
import { connect } from "react-redux";
import TMLoader from "../../../../components/Loader/Loader";
import UserGreeting from "../../../../components/UserGreeting/UserGreeting";
import TitleWrapper from "../../../../components/TitleWrap/TitleWrap";
import {
  TOActions,
  productsYetToRackedThunk,
} from "../../../../redux/TOThunks/Action";
import { reduxStore } from "../../../../redux/store";
import OfflinePage from "../../../OfflinePage/OfflinePage";

const ToBinRackerPage = (props) => {
  const getProductsToRack = () => {
    props.history.push("/to-bin-racking");
  };
  return (
    <>
      {props.isOnline ? (
        <ToBinRackerWrapper>
          {/* <TMLoader /> */}
          <div className="centerScreen">
            <div className="headerWrapper">
              <UserGreeting />
              <TitleWrapper title={"TO Bin Racker"} />
            </div>
            <button onClick={getProductsToRack} className="bbtn submitBtn">
              Start Racking
            </button>
          </div>
        </ToBinRackerWrapper>
      ) : (
        <OfflinePage />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

export default connect(mapStateToProps, { productsYetToRackedThunk })(
  ToBinRackerPage
);
